import { render, staticRenderFns } from "./QueuePush.vue?vue&type=template&id=2ec664e0&scoped=true"
import script from "./QueuePush.vue?vue&type=script&lang=js"
export * from "./QueuePush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec664e0",
  null
  
)

export default component.exports